import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M29.965 13.005a3 3 0 0 0-5.193-2.045l-9.927 10.635a3.5 3.5 0 0 0 .004 4.78l9.94 10.619a3 3 0 0 0 5.19-2.052zM16.309 25.009a1.5 1.5 0 0 1-.002-2.049l9.927-10.636a1 1 0 0 1 1.731.682l.014 21.937a1 1 0 0 1-1.73.684z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Arrow-Left-Outlined_svg__a",
      width: 17,
      height: 28,
      x: 13,
      y: 10,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M29.965 13.005a3 3 0 0 0-5.193-2.045l-9.927 10.635a3.5 3.5 0 0 0 .004 4.78l9.94 10.619a3 3 0 0 0 5.19-2.052zM16.309 25.009a1.5 1.5 0 0 1-.002-2.049l9.927-10.636a1 1 0 0 1 1.731.682l.014 21.937a1 1 0 0 1-1.73.684z",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Arrow-Left-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgArrowLeftOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ArrowLeftOutlined_default = SvgArrowLeftOutlined;

export { ArrowLeftOutlined_default as default };
